export default {
    url: '/detail/:id',
    template: `
        <div class="person01">
            <!--<div class="img small todo">-->
                <!--<img ng-src="assets/tmp/img02.jpg">-->
            <!--</div>-->
            <div class="txt">
                <div class="heading01 type01">
                    <a class="btn discrete" ui-sref="authorized.manage.permissions.users.list.tms()">{{ 'general.Back to list' | translate }}</a>
                    <h1>{{ vm.user.displayName }}</h1>
                </div>
                <p><strong>{{ vm.user.sites.length }}</strong> {{ 'manage.Sites' | translate }}</p>
            </div>
        </div>
        <ul class="tabs01">
            <li>
                <a ui-sref="authorized.manage.permissions.users.detail.sites()"
                ui-sref-active="active">{{ 'manage.Sites' | translate }}</a>
            </li>
            <li>
                <a ui-sref="authorized.manage.permissions.users.detail.company()"
                ui-sref-active="active">{{ 'manage.Company' | translate }}</a>
            </li>
        </ul>
        <ui-view></ui-view>
    `,
    abstract: true,
    resolve: {
        user (UserResource, $stateParams) {
            return UserResource.get({ id: $stateParams.id, expand: 'sites,userAssignments,roles' }).$promise;
        },
        sites (SiteResource) {
            return SiteResource.query({ pageSize: 0 }).$promise;
        }
    },
    controller (user, sites) {
        this.user = user;
        this.sites = sites;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/users/detail/index.js